import { jsx as _jsx } from "react/jsx-runtime";
import { Link as ReactRouterLink } from 'react-router-dom';
import { Link } from '../Link';
export const RouterLink = (props) => _jsx(Link, { component: ReactRouterLink, ...props });
